// extracted by mini-css-extract-plugin
export default {"imageWrapper":"mE-z","hovered":"nE-z","hoverImage":"oE-z","mainImage":"pE-z","imageNoBackground":"qE-z","fullSizeImage":"rE-z"};